import { HttpClient, HttpParams } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH } from "../variables";
import {
  StaffBranchResponse,
  StaffCompanyReferenceResponse,
  StaffCostCenterResponse,
  StaffDepartmentResponse,
  StaffPositionResponse,
} from "../model/organization-reference.model";
import { StaffPositionsService } from "./staff-positions.service";

@Injectable({ providedIn: "root" })
export class StaffOrganizationReferenceService {
  private readonly apiUrl: string;

  constructor(
    private readonly http: HttpClient,
    private readonly positions: StaffPositionsService,
    @Inject(BASE_PATH) basePath: string,
  ) {
    this.apiUrl = `${basePath.replace(/\/$/, "")}/api/v1`;
  }

  listCompanies(): Observable<StaffCompanyReferenceResponse[]> {
    return this.http.get<StaffCompanyReferenceResponse[]>(
      `${this.apiUrl}/companies`,
    );
  }

  listBranches(companyId?: number): Observable<StaffBranchResponse[]> {
    return this.listByCompany<StaffBranchResponse>("branches", companyId);
  }

  listDepartments(): Observable<StaffDepartmentResponse[]> {
    return this.http.get<StaffDepartmentResponse[]>(
      `${this.apiUrl}/departments`,
    );
  }

  listPositions(departmentId?: number): Observable<StaffPositionResponse[]> {
    return this.positions.list(departmentId);
  }

  listCostCenters(companyId?: number): Observable<StaffCostCenterResponse[]> {
    return this.listByCompany<StaffCostCenterResponse>(
      "cost-centers",
      companyId,
    );
  }

  private listByCompany<T>(
    resource: string,
    companyId?: number,
  ): Observable<T[]> {
    let params = new HttpParams();
    if (companyId != null) params = params.set("companyId", companyId);
    return this.http.get<T[]>(`${this.apiUrl}/${resource}`, { params });
  }
}
